<template>
  <div class="tw:flex">
    <template v-if="swatches && swatches.length > 0">
      <input
        v-for="(swatch,i) in swatches" :key="swatch[0] || i"
        v-bind="$attrs"
        type="color"
        inline
        :value="swatch[0]"
        class="tw:rounded-[8px] tw:border-0 tw:px-0 tw:cursor-pointer"
        @click.prevent.stop="onSelect(swatch[0])"
      />
    </template>

    <input
      v-else
      v-bind="$attrs"
      type="color"
      inline
      :value="modelValue"
      class="tw:rounded-[8px] tw:border-0 tw:px-0 tw:cursor-pointer"
      @input="onInput"
      @change="onChange"
    />
  </div>
</template>

<script lang="ts" setup>

	const emit = defineEmits<{
		(e: 'select', value: string): void;
		(e: 'update:modelValue', value: string): void;
		(e: 'click.prevent.stop:handleClickColor', value: string ): void;
		(e: 'validate'): void;
	}>()

	withDefaults(defineProps<{
		swatches?: Array<[string, string]> | undefined;
		modelValue?: string | number;
	}>(), {
		swatches: () => [],
		modelValue: '',
	})

	const onSelect = (value: string) => {
		emit('select', value);
		emit('update:modelValue', value);
		emit('click.prevent.stop:handleClickColor', value);
	}

	const onInput = (event: Event) => {
		const val = (event.target as HTMLInputElement).value;
		emit('update:modelValue', val);
	}

	const onChange = (event: Event) => {
		const val = (event.target as HTMLInputElement).value;
		emit('update:modelValue', val);
		emit('select', val);
	}

</script>

<style scoped>

	input[type="color"] {
		-webkit-appearance: none;
		border: none;
		padding: 0;
		background: none;
		width: 32px;
		height: 32px;
		margin: 0 2px;
	}
	input[type="color"]::-webkit-color-swatch-wrapper {
		padding: 0;
	}
	input[type="color"]::-webkit-color-swatch {
		border: none;
		border-radius: 10px;
	}
	input[type="color"]::-moz-color-swatch {
		border: none;
		border-radius: 10px;
	}
	
</style>